import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./navigation.${locale}.json`));
